export default "__VITE_ASSET__CK65GRj0__"